!(function() {
  var ReportDesignerConstants = require('logic/data/Izenda.ReportDesignerConstants');
  const { includes } = require('lodash/fp');

  function isImage(dataType) {
    return includes(dataType, ReportDesignerConstants.DATA_TYPES.IMAGE);
  }

  function isBinary(dataType) {
    var DATA_TYPES = ReportDesignerConstants.DATA_TYPES;
    return includes(dataType, [DATA_TYPES.IMAGE, DATA_TYPES.LOB, DATA_TYPES.XML, DATA_TYPES.JSON]);
  }

  module.exports = {
    isImage: isImage,
    isBinary: isBinary
  };
})();



// WEBPACK FOOTER //
// ./ui/share/utils/Izenda.ObjectUtils.js